import { render } from "./NotificationBubble.vue?vue&type=template&id=4576a475"
import script from "./NotificationBubble.vue?vue&type=script&lang=js"
export * from "./NotificationBubble.vue?vue&type=script&lang=js"

import "./NotificationBubble.vue?vue&type=style&index=0&id=4576a475&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__